
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import BottleScreen from './bottle';
import ClassicCocktailsScreen from './classicCocktails';
import BeersScreen from './beers';
import Alcoholic from './alcoholic';

const WOOD_BUTTON_BG = require('./assets/botonmadera.png');

function Index({setShowHappy}) { 

     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [tacos, settacos] = useState(false);
    const [burritos, setburritos] = useState(false);
    const [quesadillas, setquesadillas] = useState(false);
    const [mexicanTortas, setmexicanTortas] = useState(false);
 
  
    const [dishs, setdishs] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
        const [showBottle, setShowBottle] = useState(false);
        const [showClassicCocktails, setShowClassicCocktails] = useState(false);
        const [showBeers, setShowBeers] = useState(false);

    const targetCategoryNames = [
        'TACOS',
        'BURRITOS & CHIMICHANGAS',
        'QUESADILLAS',
        'MEXICAN TORTAS',
    ];

    const tacoCategories = targetCategoryNames
        .map((name) => menusData.find((item) => (item.name || '').toUpperCase() === name))
        .filter(Boolean);
    
     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
            setMenusData(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 797) {
                settacos(item);
            }
            if (item.id === 791) {
                setburritos(item);
            }
            if (item.id === 798) {
                setquesadillas(item);
            }
            if (item.id === 792) {
                setmexicanTortas(item);
            }
            
            
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={setshowCategories} showCocktails={setShowCocktails} showEvents={setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>

                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        <div>
                            <img
                            src={require('./assets/letrerotacos.png')}
                            onContextMenu={(e) => e.preventDefault()}
                                style={{
                                marginTop: -100,
                                width: '100%',
                                height: 200,
                                marginBottom: 6,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>


                        <div style={{
                            display: 'flex', flexWrap: 'wrap',
                            justifyContent: 'center', alignItems: 'center', gap: 14,
                            paddingInline: 10, marginTop: -10, flexFlow: 'column',
                            marginTop: 100
                        }}>
                            {tacoCategories.map((item) => (
                                <div
                                    key={item.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: item.name.toUpperCase() === 'BURRITOS & CHIMICHANGAS' ? '95%' : '48%',
                                        height: 70,
                                        position: 'relative',
                                        cursor: 'pointer',
                                        borderRadius: 12,
                                        backgroundImage: `url(${WOOD_BUTTON_BG})`,
                                        backgroundSize: '100% 100%',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        marginBottom: 30,
                                        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.35)',
                                    }}
                                    onClick={() => {
                                        setShowListProduct(true);
                                        if(item.name === 'TACOS'){
                                            setdishs(tacos);
                                        }
                                         else if (item.name === 'BURRITOS & CHIMICHANGAS') {
                                             setdishs(burritos);
                                        }
                                        else if (item.name === 'QUESADILLAS') {
                                             setdishs(quesadillas);
                                        }
                                        else if (item.name === 'MEXICAN TORTAS') {
                                            setdishs(mexicanTortas);
                                        }
                                        
                                    }}
                                >
                                    <p
                                        style={{
                                            color: '#fff',
                                            fontSize: 30,
                                            fontWeight: 900,
                                            textAlign: 'center',
                                            fontFamily: 'Galantic, Impact, Arial Black, Arial, sans-serif',
                                            textTransform: 'uppercase',
                                            margin: 0,
                                            lineHeight: 1.05,
                                            textShadow: '0px 2px 2px rgba(0, 0, 0, 0.55)',
                                            paddingInline: 20,
                                        }}
                                    >
                                        {item.name}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showClassicCocktails && <ClassicCocktailsScreen setShowHappy={setShowClassicCocktails} />}
                {showBeers && <BeersScreen setShowHappy={setShowBeers} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;